import { queryAll, query, fromId } from '../utils/utils.js';
import instantsearch from 'instantsearch.js';

import algoliasearch from "algoliasearch";
import {
	configure,
	hits,
	pagination,
	searchBox,
	stats,
	currentRefinements,
	clearRefinements,
	refinementList,
	sortBy
} from 'instantsearch.js/es/widgets';
import { setAisSearchBoxAriaLabel } from './accessibility-helpers.js';

const SITE_SEARCH_ARIA_LABEL = 'Search this website';

export class SiteSearch {

	constructor() {
	}


	init(){
		const facetOrder = ['page','specialties', 'services', 'providers', 'locations'];
		const search = instantsearch({
			indexName: window.ALGOLIA_INDEX_PREFIX+'fullsite',
			searchClient: algoliasearch(
			  'LTCGWA12RB',
			  'fbbd5f8b545361104df6b21dfd244cc1'
			),
			routing: true,
			searchFunction(helper) {
				// Ensure we only trigger a search when there's a query
				if (helper.state.query) {
				  helper.search();
				}
			},
		});

		search.addWidgets([
			searchBox({
			  container: "#searchbox",
			  placeholder: "Search"

			}),
			configure({
				hitsPerPage: 10,
			}),
			stats({
				container: '#stats',
				templates: {
					text(data, { html }) {
					  if (data.hasManyResults || data.hasOneResult){
						return html`<h4>Search Results (${data.nbHits})</h4>`;
					  }
					  return html`<h4>Search Results (0)</h4>`;
					}
				}
			}),
			stats({
				container: '#bottom-stats',
				templates: {
					text(data, { html }) {
					  if (data.hasManyResults || data.hasOneResult){
						let showing = data.page * data.hitsPerPage;
						if (data.page === 0) {
							if(data.nbHits < data.hitsPerPage){
								showing = data.nbHits;
							}else{
								showing = data.hitsPerPage;
							}
						}else if(data.page >= 1){
							showing = (data.page * data.hitsPerPage+1) + "-" + (data.page * data.hitsPerPage + data.hitsPerPage);
						}
						return html`<p>Showing ${showing}  of ${data.nbHits} results</p>`;
					  }
					  return html``;
					}
				}
			}),
			refinementList({
				container: '#refinement-list',
				attribute: 'type',
				operator: 'or',
				limit: 7,
				templates: {
					item(item, { html }) {
					  const { url, label, count, isRefined } = item;

					  return html`
						<a href="${url}" class="bhs-link-button  primary-btn ${isRefined ? 'dark' : 'light'} ">
						  <span>${label} (${count})</span>
						</a>
					  `;
					},
				  },
				// sortBy: ['name:asc'],
				sortBy: ((a, b) => {//our custom sort
					const aIndex = facetOrder.indexOf(a.name);
					const bIndex = facetOrder.indexOf(b.name);
					if (aIndex !== -1 && bIndex !== -1) {
					  return aIndex - bIndex;
					} else if (aIndex !== -1) {
					  return -1;
					} else if (bIndex !== -1) {
					  return 1;
					} else {
						if (a < b) {
							return -1;
						  } else if (a > b) {
							return 1;
						  } else {
							return 0;
						  }
					}
				  }),
				transformItems2(items) {//maybe change the name here?
					console.log(items);
					items.sort((a, b) => {
						if (firstFacets.includes(a) && !firstFacets.includes(b)) {
						  return -1;
						} else if (!firstFacets.includes(a) && firstFacets.includes(b)) {
						  return 1;
						} else {
						  return a;
						}
					});
					console.log(items);
					return items.map(item => ({
					  ...item,
					  highlighted: item.highlighted.toUpperCase(),
					}))
				}
			}),
			hits({
			  container: "#hits",
			  templates: {
				empty(results, { html }) {
					return html`<div class="no-results">No results found for <q>${results.query}</q><p>Try searching by provider, location, condition or treatment.</p></div>`;

				},
				item(hit, { html, components }) {
					// console.log(hit);
					return html`
						<div class="search-item">
							<img src="${hit.image}" style="${hit.image != '' ? '' : 'display: none;'}"/>
							<div class="left-side">
								<div class="page-type">${hit.type}</div>
								<a class="page-title" href="${hit.url}">
									${components.Highlight({ hit, attribute: 'title' })}
								</a>
								<div class="url">${window.location.hostname}${hit.url}</div>
								<p>${components.Snippet({ hit, attribute: 'content' })}</p>
							</div>
							<div class="right-side">
								<a href="${hit.url}" class="bhs-link-button arrow-link icon-btn light"></a>
							</div>
						</div>
					`;
				  },
			  },
			}),
			pagination({
				container: '#pagination',
				padding: 2,
				scrollTo: '#stats',
			  }),
		  ]);

		search.start();
		setAisSearchBoxAriaLabel('#searchbox', SITE_SEARCH_ARIA_LABEL);

		search.on('render', () => {
			setAisSearchBoxAriaLabel('#searchbox', SITE_SEARCH_ARIA_LABEL);
			window.addArrowLinks();

			if (search.helper?.lastResults?.hits.length === 0){
				document.querySelector('.search-page').classList.add("no-results-found")
			}else{
				document.querySelector('.search-page').classList.remove("no-results-found")
			}
		});
	}

}
